/* Product card behaviour: in-card variant switching, quick add, wishlist.
   Without this file the card stays a plain link to the product page. */

(function () {
  'use strict';
  /* Secties nemen dit bestand elk zelf op, dus staat het soms twee of drie keer
     op één pagina. De browser voert elke tag dan opnieuw uit, waardoor listeners
     op document dubbel hangen en één klik twee acties uitvoert. Deze poort laat
     alleen de eerste uitvoering door. */
  window.__hwsLoaded = window.__hwsLoaded || {};
  if (window.__hwsLoaded['component_product_card']) return;
  window.__hwsLoaded['component_product_card'] = true;


  var strings = window.hwsStrings || {};
  var config = window.hwsSettings || {};

  class HwsCardForm extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('[data-product-card]');
      this.variants = this.readVariants();
      this.form = this.querySelector('[data-card-quick-add]');
      this.idInput = this.querySelector('[data-card-variant-id]');
      this.addButton = this.querySelector('[data-card-add]');
      this.addText = this.querySelector('[data-card-add-text]');
      this.errorEl = this.querySelector('[data-card-error]');

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }
      this.current = this.currentVariant();
    }

    readVariants() {
      var script = this.querySelector('[data-card-variants]');
      if (!script) return [];
      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return [];
      }
    }

    currentVariant() {
      var id = this.idInput ? this.idInput.value : null;
      if (!id) {
        var pressed = this.querySelector('[data-card-variant][aria-pressed="true"]');
        if (pressed) id = pressed.getAttribute('data-card-variant');
      }
      if (!id) {
        var select = this.querySelector('[data-card-variant-select]');
        if (select) id = select.value;
      }
      return this.findVariant(id);
    }

    findVariant(id) {
      if (!id) return this.variants[0];
      for (var i = 0; i < this.variants.length; i++) {
        if (String(this.variants[i].id) === String(id)) return this.variants[i];
      }
      return this.variants[0];
    }

    onClick(event) {
      var button = event.target.closest('[data-card-variant]');
      if (!button) return;
      event.preventDefault();
      if (button.getAttribute('aria-disabled') === 'true') return;
      this.querySelectorAll('[data-card-variant]').forEach(function (el) {
        el.setAttribute('aria-pressed', 'false');
        el.classList.remove('is-selected');
      });
      button.setAttribute('aria-pressed', 'true');
      button.classList.add('is-selected');
      this.select(button.getAttribute('data-card-variant'));
    }

    onChange(event) {
      if (event.target.matches('[data-card-variant-select]')) {
        this.select(event.target.value);
      }
    }

    select(id) {
      var variant = this.findVariant(id);
      if (!variant) return;
      this.current = variant;
      if (this.idInput) this.idInput.value = variant.id;

      var card = this.card;
      if (!card) return;

      var priceEl = card.querySelector('[data-price]');
      if (priceEl) priceEl.textContent = variant.priceText;

      var compareEl = card.querySelector('[data-compare-price]');
      var priceWrap = card.querySelector('[data-price-wrapper]');
      if (compareEl) {
        if (variant.compare && variant.compare > variant.price) {
          compareEl.hidden = false;
          compareEl.textContent = variant.compareText;
        } else {
          compareEl.hidden = true;
        }
      }
      if (priceWrap) {
        priceWrap.classList.toggle(
          'price--on-sale',
          !!(variant.compare && variant.compare > variant.price)
        );
      }

      var titleMeta = card.querySelector('[data-card-variant-title]');
      if (titleMeta) titleMeta.textContent = variant.title;

      var image = card.querySelector('[data-card-image]');
      if (image && variant.image) {
        image.removeAttribute('srcset');
        image.src = variant.image;
      }

      var media = card.querySelector('[data-card-media]');
      if (media) media.setAttribute('href', variant.url);
      var titleLink = card.querySelector('[data-card-title]');
      if (titleLink) titleLink.setAttribute('href', variant.url);

      this.updateStock(variant);
      this.updateButton(variant);
      this.updateDelivery(variant);
    }

    /* De bezorgregel wordt alleen server-side gerenderd voor de variant waarmee
       de kaart begint. Koos je daarna een uitverkochte tint, dan stond er
       "Uitverkocht" met daaronder nog steeds "morgen in huis". Bij een
       uitverkochte variant halen we die regel dus weg, en bij een leverbare zetten
       we hem terug. */
    updateDelivery(variant) {
      /* Voorraad en bezorging staan in één regel. Bij een niet-leverbare variant
         hoort de bezorgbelofte weg, maar de voorraadregel juist te blijven staan
         (die zegt dan "Uitverkocht"). Dus verbergen we alleen de belofte en halen
         we het beige vlak weg. */
      var el = this.card && this.card.querySelector('.card__delivery');
      if (el) el.hidden = !variant.available;
      var scheiding = this.card && this.card.querySelector('.card__status-sep');
      if (scheiding) scheiding.hidden = !variant.available;
      var regel = this.card && this.card.querySelector('[data-card-status]');
      if (regel) regel.classList.toggle('card__status--plain', !variant.available);
      if (!this.card) return;
      /* Uitverkocht vervangt de badges: korting én "nieuw" naast een balk
         "Tijdelijk uitverkocht" leest als drie tegenstrijdige mededelingen. */
      var balk = this.card.querySelector('[data-card-soldout]');
      if (balk) balk.hidden = !!variant.available;
      var badges = this.card.querySelector('.hws-badges');
      if (badges) badges.hidden = !variant.available;
    }

    updateStock(variant) {
      var el = this.card && this.card.querySelector('[data-stock-status]');
      if (!el) return;
      el.className = 'hws-status';
      if (!variant.available) {
        el.classList.add('hws-status--out');
        el.textContent = strings.soldOut;
        return;
      }
      if (variant.tracked && variant.inventory <= 0 && variant.policy === 'continue') {
        el.classList.add('hws-status--preorder');
        el.textContent = strings.preorder || 'Pre-order';
        return;
      }
      el.classList.add('hws-status--in');
      el.textContent = strings.inStock || el.textContent;
    }

    updateButton(variant) {
      if (!this.addButton) return;
      this.addButton.disabled = !variant.available;
      if (this.addText) {
        this.addText.textContent = variant.available
          ? this.addText.getAttribute('data-default') ||
            this.addText.textContent ||
            strings.addToCart
          : strings.soldOut;
      }
      if (variant.available && this.addText) {
        var fallback = this.addText.getAttribute('data-default');
        if (fallback) this.addText.textContent = fallback;
      }
    }

    onSubmit(event) {
      if (!window.fetch || !config.routes) return;
      event.preventDefault();
      var button = this.addButton;
      if (!button || button.disabled) return;
      var quantityInput = this.querySelector('.quantity__input');
      var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      var id = this.idInput ? this.idInput.value : null;
      if (!id) return;

      if (this.errorEl) {
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
      button.classList.add('btn--loading');
      button.setAttribute('aria-busy', 'true');

      var self = this;
      window.hwsCart
        .add([{ id: Number(id), quantity: quantity }])
        .then(function (data) {
          if (data.__error || data.status) {
            var message = data.description || data.message || strings.cartError;
            if (self.errorEl) {
              self.errorEl.textContent = message;
              self.errorEl.hidden = false;
            }
            window.hwsAnnounce(message);
            return;
          }
          window.hwsCart.renderSections(data);
          window.hwsCart.fetchState().then(function (state) {
            window.hwsCart.syncCount(state);
          });
          if (config.cartType === 'drawer' && document.getElementById('CartDrawer')) {
            window.hwsOverlay.open('CartDrawer');
          } else {
            window.hwsToast.show(strings.addedToCart);
          }
        })
        .catch(function () {
          if (self.errorEl) {
            self.errorEl.textContent = strings.cartError;
            self.errorEl.hidden = false;
          }
        })
        .finally(function () {
          button.classList.remove('btn--loading');
          button.removeAttribute('aria-busy');
        });
    }
  }

  if (!customElements.get('hws-card-form')) {
    customElements.define('hws-card-form', HwsCardForm);
  }

  /* ------------------------------------------------------- Colour swatches */

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-swatch-variant]');
    if (!swatch) return;
    var card = swatch.closest('[data-product-card]');
    if (!card) return;
    event.preventDefault();
    var image = card.querySelector('[data-card-image]');
    var src = swatch.getAttribute('data-swatch-image');
    if (image && src) {
      image.removeAttribute('srcset');
      image.src = src;
    }
    var url = swatch.getAttribute('data-swatch-url');
    if (url) {
      var media = card.querySelector('[data-card-media]');
      var title = card.querySelector('[data-card-title]');
      if (media) media.setAttribute('href', url);
      if (title) title.setAttribute('href', url);
    }
    card.querySelectorAll('[data-swatch-variant]').forEach(function (el) {
      el.classList.remove('is-selected');
      el.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-pressed', 'true');
    var form = card.querySelector('[data-card-form]');
    if (form && form.select) form.select(swatch.getAttribute('data-swatch-variant'));
  });

  /* ------------------------------------------------------------- Wishlist */

  var WISHLIST_KEY = 'hws:wishlist';

  function readWishlist() {
    try {
      return JSON.parse(window.localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(list) {
    try {
      window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (error) {
      /* storage unavailable — the button still toggles visually */
    }
  }

  function syncWishlistButtons() {
    var list = readWishlist();
    document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      button.setAttribute('aria-pressed', list.indexOf(handle) !== -1 ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-button]');
    if (!button) return;
    event.preventDefault();
    var handle = button.getAttribute('data-product-handle');
    var list = readWishlist();
    var index = list.indexOf(handle);
    if (index === -1) {
      list.push(handle);
    } else {
      list.splice(index, 1);
    }
    writeWishlist(list);
    syncWishlistButtons();
    document.dispatchEvent(
      new CustomEvent('hws:wishlist:changed', { detail: { handle: handle, list: list } })
    );
  });

  /* Fotovlak van de kaart: opent het adres van de titellink (die houdt de gekozen variant bij). */
  function openKaart(e) {
    var media = e.target.closest && e.target.closest('[data-card-media]');
    if (!media || e.target.closest('a, button, input, label, select')) return;
    var card = media.closest('[data-product-url]') || media.parentNode;
    var link = card && card.querySelector('[data-card-title]');
    var url = link ? link.getAttribute('href') : card && card.getAttribute('data-product-url');
    if (!url) return;
    if (e.type === 'auxclick' && e.button !== 1) return;
    if (e.metaKey || e.ctrlKey || e.button === 1) window.open(url, '_blank');
    else window.location.href = url;
  }
  document.addEventListener('click', openKaart);
  document.addEventListener('auxclick', openKaart);

  document.addEventListener('DOMContentLoaded', syncWishlistButtons);
  document.addEventListener('shopify:section:load', syncWishlistButtons);
  document.addEventListener('hws:cart:updated', syncWishlistButtons);
  syncWishlistButtons();
})();
